import { useMemo } from "react";
import { useCartStore } from "../stores/useCartStore";
import { motion } from "framer-motion";

const methods = [
  { id: "standard", title: "משלוח עד הבית", subtitle: "3–7 ימי עסקים", price: 46 },
  { id: "pickup", title: "איסוף עצמי", subtitle: "בתיאום מראש", price: 0 },
  { id: "free", title: "משלוח חינם", subtitle: "בקנייה מעל 299₪", price: 0 }
];

const ShippingOptions = () => {
  const { subtotal, shippingMethod, shippingCost, setShippingMethod } = useCartStore();

  const computed = useMemo(() => {
    // חינם אוטומטית מעל 299 — מיועד להצגה בלבד (החישוב נעשה בסטור)
    const isEligibleForFree = subtotal >= 299;
    return { isEligibleForFree };
  }, [subtotal]);

  return (
    <motion.div
      className="space-y-4 rounded-lg border border-gray-200 bg-white p-4 shadow-sm sm:p-6"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <p className="text-xl font-semibold" style={{ color: 'var(--brand-primary)' }}>
        בחירת משלוח
      </p>

      <div className="space-y-3">
        {methods.map((m) => {
          // חסימת בחירה ידנית של "חינם" אם לא זכאים — אבל נציג את האופציה עם הסבר
          const disabled = (m.id === 'free' && !computed.isEligibleForFree);
          const isActive = shippingMethod === m.id;
          const price = m.id === 'standard' ? 46 : 0;

          return (
            <button
              key={m.id}
              type="button"
              onClick={() => !disabled && setShippingMethod(m.id)}
              className={`w-full text-right p-3 border rounded-lg transition-all ${
                isActive ? 'border-[var(--brand-primary)] ring-2 ring-[rgba(100,13,70,0.15)]' : 'border-gray-200'
              } ${disabled ? 'opacity-60 cursor-not-allowed' : 'hover:border-[var(--brand-primary)]'}`}
              style={{ '--tw-ring-color': 'rgba(100, 13, 70, 0.15)' }}
            >
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-medium text-gray-900">{m.title}</div>
                  <div className="text-sm text-gray-600">{m.subtitle}</div>
                  {m.id === 'free' && !computed.isEligibleForFree && (
                    <div className="text-xs text-gray-500 mt-1">זמין אוטומטית מעל 299₪</div>
                  )}
                </div>
                <div className="text-[var(--brand-primary)] font-bold">
                  {price === 0 ? 'חינם' : `₪${price}`}
                </div>
              </div>
            </button>
          );
        })}
      </div>

      <div className="pt-2 border-t text-sm text-gray-600">
        עלות משלוח נוכחית: <span className="font-bold text-gray-900">{shippingCost === 0 ? 'חינם' : `₪${shippingCost}`}</span>
      </div>
    </motion.div>
  );
};

export default ShippingOptions;
